/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { deleteUndefineds } from '@zcode-ui/map'
import type { EnumTitle, IntegratedTourType } from '@zcode/enums'
import { EVENT_NAMES, PROP_NAMES, type TOUR_PREFERENCE_TYPES, track } from '@zcode/mixpanel'
import type { Origin } from '@zcode/nr-utils'
import type { Listable, Property } from '@zcode/state-type'
import type { Dispatch, GetState } from '../../types'
import type { PageName } from '../helpers'
import { getCommonProps } from '../helpers/getCommonProps'
import type { getFormattedOrigin } from '../helpers/getFormattedOrigin'

interface Props {
  entity: Listable | Property
  formattedOrigin: ReturnType<typeof getFormattedOrigin>
  origin?: Origin
  pageName?: PageName | string
  selectedTourType?: EnumTitle<typeof IntegratedTourType, IntegratedTourType>
  tourPreferenceCount?: number
  tourPreferenceType?: (typeof TOUR_PREFERENCE_TYPES)[keyof typeof TOUR_PREFERENCE_TYPES]
}

export const mixpanelSendMessage =
  ({
    entity,
    formattedOrigin,
    origin,
    pageName,
    selectedTourType,
    tourPreferenceCount,
    tourPreferenceType,
  }: Props) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const payload = {
      ...getCommonProps({ state, entity, pageName, event: EVENT_NAMES.SEND_MESSAGE }),
      [PROP_NAMES.ORIGIN]: origin,
      [PROP_NAMES.FORMATTED_ORIGIN]: formattedOrigin,
      [PROP_NAMES.SELECTED_TOUR_TYPE]: selectedTourType,
      [PROP_NAMES.TOUR_PREFERENCE_COUNT]: tourPreferenceCount,
      [PROP_NAMES.TOUR_PREFERENCE_TYPE]: tourPreferenceType,
    }
    track({ event: EVENT_NAMES.SEND_MESSAGE, payload: deleteUndefineds(payload) })
  }
